// Greeting rules per user request:
//   < 12  → "Good morning"
//   12–16 → "Good afternoon"
//   16–21 → "Good evening"
//   ≥ 21  → "It's late"
export function greetingFor(name) {
  const h = new Date().getHours();
  const first = (name || "").split(" ")[0] || "there";
  let phrase;
  if (h < 12) phrase = "Good morning";
  else if (h < 16) phrase = "Good afternoon";
  else if (h < 21) phrase = "Good evening";
  else phrase = "It's late";
  return { phrase, first, full: `${phrase}, ${first}` };
}
